import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactBootstrapSlider from 'react-bootstrap-slider';

import { setTimeRange } from '../../../actions/filterActions';

import '../../../../node_modules/bootstrap-slider/dist/css/bootstrap-slider.min.css';
import './TimeSlider.css';

class TimeSlider extends Component {
  constructor(props) {
    super(props);

    const MINUTES_PER_HOUR = 60;
    const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

    this.rangeMin = 0;
    this.rangeMax = MINUTES_PER_DAY;
    this.timeStepInMinutes = 15;

    // calculate the possible time steps in minutes
    // using an increment of timeStepInMinutes
    const possibleStepsInMinutes = _.range(
      this.rangeMin,
      this.rangeMax + this.timeStepInMinutes,
      this.timeStepInMinutes
    );

    this.timeSlotIntervals = {};

    possibleStepsInMinutes.forEach(timeStep => {
      const hours = Math.floor(timeStep / MINUTES_PER_HOUR);
      const minutes = timeStep % MINUTES_PER_HOUR;

      // sliderValue is stored in State, so add it in here
      // we still want a hash instead of an array for faster lookup
      this.timeSlotIntervals[timeStep] = {
        hours,
        minutes,
        sliderValue: timeStep
      };
    });

    this.state = {
      timeRange: {
        timeRangeStart: this.rangeMin,
        timeRangeEnd: this.rangeMax
      }
    };
  }

  componentWillMount() {
    if (_.isEmpty(this.props.timeRange)) {
      // initialize this.props.timeRange
      const timeRange = { timeRangeStart: null, timeRangeEnd: null };

      timeRange.timeRangeStart = this.timeSlotIntervals[this.rangeMin];
      timeRange.timeRangeEnd = this.timeSlotIntervals[this.rangeMax];

      this.props.setTimeRange(timeRange);
    }
  }

  handleSlideStop = (event) => {
    const timeRange = {};
    const start = event.target.value[0];
    const end = event.target.value[1];

    timeRange.timeRangeStart = this.timeSlotIntervals[start];
    timeRange.timeRangeEnd = this.timeSlotIntervals[end];

    this.props.setTimeRange(timeRange);
  }

  handleSliderChange = (event) => {
    this.setState({
      timeRange: {
        timeRangeStart: event.target.value[0],
        timeRangeEnd: event.target.value[1]
      }
    });
  }

  formatSlideValue = (value) => {
    // the slider is returning both scalar values and an array of values
    // so only return a string when the input value is a scalar number
    if (typeof value === 'number') {
      const time = this.timeSlotIntervals[value];
      const displayTime = moment()
        .hours(time.hours)
        .minutes(time.minutes);

      return `${displayTime.format('h:mm A')}`;
    }

    return null;
  }

  render() {
    let sliderValues = 0;

    // if this.props.timeRange has keys, use the data to update sliderValues
    // the values are stored in the sliderValue property
    if (_.keys(this.state.timeRange).length > 0) {
      sliderValues = _.keys(this.state.timeRange).map(key => parseInt(
        this.state.timeRange[key], 10
      ));
    }

    return (
      <div className="TimeSlider filter-sidebar-component flex-md-unordered flex-last row no-gutters">
        <div className="col">
          <label className="d-block hidden-sm-down pull-left mb-3 text-left">TIME</label>

          <div className="clearfix" />

          <div className="d-flex justify-content-between">
            <label>{this.formatSlideValue(this.state.timeRange.timeRangeStart)}</label>
            <label>{this.formatSlideValue(this.state.timeRange.timeRangeEnd)}</label>
          </div>

          <ReactBootstrapSlider
            id="time-of-day-filter"
            range
            min={this.rangeMin}
            max={this.rangeMax}
            step={this.timeStepInMinutes}
            value={sliderValues}
            tooltip_split
            tooltip="hide"
            change={value => this.handleSliderChange(value)}
            formatter={value => this.formatSlideValue(value)}
            slideStop={event => this.handleSlideStop(event)}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { timeRange: state.filters.timeRange };
}

export default connect(mapStateToProps, { setTimeRange })(TimeSlider);



// WEBPACK FOOTER //
// ./src/components/filters/TimeSlider/TimeSlider.js